module.exports = __webpack_public_path__ + "static/media/door_hardware.f79854f1.jpg";